<template>
  <div class="text-credits-container">
    <BContainer>
      <BRow class="justify-content-center">
        <BCol cols="12" md="6">
          <div :key="key" v-for="(el, key) in text">
            <div :key="`${type}_${key}`" v-for="(content, type) in el">
              <div v-html="content" v-if="type==`text`"></div>
              <RawInline :src="content" v-if="type==`raw`" />
              <RawInteractive :src="content" v-if="type==`raw_interactive`" />
              <ImageInline :src="content" v-if="type==`photo`" />
              <ImageInlineScroll :src="content" v-if="type==`photo_scroll`" />
            </div>
          </div>
        </BCol>
      </BRow>
    </BContainer>
  </div>
</template>

<style lang="scss">

  .text-credits-container {
    padding: 35px 0;

    h2 {
      font-family: "Roboto";
      font-size: 16px;
      padding-bottom: 15px;
    }

    img {
      width: 100%;

      &.sponsor {
        max-width: 260px !important;
      }
    }
  }

</style>

<script>

  import RawInteractive from '@/components/RawInteractive'
  import RawInline from '@/components/RawInline'
  import ImageInline from '@/components/ImageInline'
  import ImageInlineScroll from '@/components/ImageInlineScroll'

  export default {
    name: 'TextCredits',
    props: {
      text: Array
    },
    components: {
      RawInteractive,
      RawInline,
      ImageInline,
      ImageInlineScroll
    }
  }
</script>